import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/card'
import { Plus } from 'lucide-react'
import { useAdScheduleTemplates } from '@/hooks/useAdScheduleTemplates'
import { PageHeader } from '@/components/PageHeader'
import { DataTable } from './data-table'
import { columns } from './columns'
import CreateTemplateDialog from './CreateTemplateDialog'
import { Skeleton } from '@/components/ui/skeleton'
import { useViewMode } from '@/stores/viewMode'

export default function AdScheduleTemplatePage() {
  const [createDialogOpen, setCreateDialogOpen] = useState(false)
  const { mode, id: viewModeId } = useViewMode()

  // When in provider mode, pass providerId to filter templates
  const providerId = mode === 'provider' && viewModeId ? viewModeId : undefined

  const { templates, isLoading, mutate } = useAdScheduleTemplates({ providerId })

  if (isLoading) {
    return (
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <div>
            <Skeleton className="h-8 w-48" />
            <Skeleton className="h-4 w-96 mt-2" />
          </div>
          <Skeleton className="h-10 w-32" />
        </div>
        <Skeleton className="h-96 w-full" />
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <PageHeader
        title="廣告排班模版管理"
        description="建立可重複使用的廣告排班模版，並套用到診所或廣播設備"
        level={mode === 'admin' ? 'page' : 'section'}
      >
        <Button onClick={() => setCreateDialogOpen(true)}>
          <Plus className="mr-2 h-4 w-4" />
          建立新模版
        </Button>
      </PageHeader>

      <Card className="p-6">
        <DataTable columns={columns} data={templates} onRefresh={mutate} />
      </Card>

      <CreateTemplateDialog
        open={createDialogOpen}
        onOpenChange={setCreateDialogOpen}
        onSuccess={() => {
          mutate()
          setCreateDialogOpen(false)
        }}
      />
    </div>
  )
}
